import { Search, DraftingCompass, Rocket, Activity } from "lucide-react";
import { SectionHead, Stagger, StaggerItem } from "@/components/Reveal";

const STEPS = [
  {
    icon: Search,
    title: "Discovery & Assessment",
    points: ["Understand your business and technical goals", "Audit current infrastructure", "Create optimization roadmap"],
  },
  {
    icon: DraftingCompass,
    title: "Architecture & Planning",
    points: ["Design cloud solution aligned with goals", "Cost projections and ROI analysis", "Security and compliance review"],
  },
  {
    icon: Rocket,
    title: "Implementation & Migration",
    points: ["Deploy infrastructure with IaC", "Migrate existing workloads", "Comprehensive testing and validation"],
  },
  {
    icon: Activity,
    title: "Optimization & Support",
    points: ["Continuous monitoring and optimization", "Cost management and reporting", "24/7 technical support and maintenance"],
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 sm:py-32 bg-nexblue overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="orbit-ring w-[560px] h-[560px] -right-56 bottom-[-180px]" style={{ borderColor: "rgba(255,149,0,0.10)" }} />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(0,168,232,0.10),transparent_50%)]" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHead
          dark
          chapter="06"
          overline="How We Work"
          title="Our Engagement Process"
          sub="A proven four-step path from first conversation to always-on optimization."
          testId="process-heading"
        />
        <div className="mt-16 relative">
          <div className="absolute left-[27px] top-2 bottom-2 w-px bg-gradient-to-b from-nexcyan via-nexcyan/40 to-nexorange lg:left-0 lg:right-0 lg:top-[27px] lg:bottom-auto lg:h-px lg:w-auto lg:bg-gradient-to-r" aria-hidden="true" />
          <Stagger className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
            {STEPS.map(({ icon: Icon, title, points }, i) => (
              <StaggerItem key={title}>
                <div className="relative pl-20 lg:pl-0 lg:pt-20" data-testid={`process-step-${i + 1}`}>
                  <div
                    className={`absolute left-0 top-0 lg:top-0 flex h-14 w-14 items-center justify-center rounded-full border-2 bg-nexblue ${
                      i % 2 === 0
                        ? "border-nexcyan shadow-[0_0_24px_rgba(0,168,232,0.45)]"
                        : "border-nexorange shadow-[0_0_24px_rgba(255,149,0,0.4)]"
                    }`}
                  >
                    <Icon size={22} className={i % 2 === 0 ? "text-nexcyan" : "text-nexorange"} />
                  </div>
                  <span className="font-display text-sm font-bold text-white/40">Step 0{i + 1}</span>
                  <h3 className="mt-2 font-display text-xl font-semibold text-white">{title}</h3>
                  <ul className="mt-4 space-y-2">
                    {points.map((p) => (
                      <li key={p} className="text-sm leading-relaxed text-white/60">{p}</li>
                    ))}
                  </ul>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </div>
    </section>
  );
}
